// extracted by mini-css-extract-plugin
module.exports = {"section":"Step4_section__Y_82C","image":"Step4_image__2dQn-","desc":"Step4_desc__3106e"};